module.exports = __webpack_public_path__ + "7f163362e78f2b67c4e55312d4bade62.fbx";